<div [class]="{ divider: showDivider }" class="option-group">
  <ng-content select="wchfs-option-group-header"></ng-content>
  <ng-content
    *ngIf="(this.header && (this.header.showGroupOptions | async)) || !this.header"
    select="wchfs-option"
  ></ng-content>
</div>
